import MainLayout from '@/components/layout/MainLayout.vue';
import Pagination from 'laravel-vue-pagination';
import StarRating from "vue-star-rating";
import VueSlider from 'vue-slider-component';
import RegionJson from '@/assets/json/region.json';
import TwspNameJson from "@/assets/json/township.json";
import axios from "axios";
import 'vue-slider-component/theme/default.css';
import $ from "jquery";
import { mapGetters } from "vuex";
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';

const convertNumberService = new ConvertNumService();

export default {
    name: 'courseList',

    components: {
        MainLayout,
        Pagination,
        VueSlider,
        StarRating,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            pg_status: false,
            category: [],
            regionArr: RegionJson,
            twspNameJson: TwspNameJson,
            selectedTwspName: "",
            twspName: [],
            keyword: "",
            sortBy: "",
            courses: {},
            teachers: {
                teacher_id: "",
                name: "",
            },
            schools: {
                school_id: "",
                name: ""
            },
            filter: {
                category_id: "",
                teacher_id: [],
                school_id: [],
                course_name: "",
                orderBy: "",
                region: "",
                town: "",
                course_type: 3,
            },
            lastPage: "",
            currentPage: "",
            isEnrolling: false, // Flag to prevent multiple clicks
        };
    },

    created() {
        this.isStudent = this.userType == "student" ? true : false;
        this.isTeacher = this.userType == "teacher" ? true : false;
    },

    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    methods: {
        getCourses(page = 1) {
            var Request =  {
                params: {
                    course_type: 3,
                }
            };  
            axios.get("course/list?page=" + page, Request)
            .then((response) => {
                this.courses = response.data;
                this.courses.total = convertNumberService.convertEng2Mm(this.courses.total);
                this.lastPage = convertNumberService.convertEng2Mm(this.courses.last_page);
                this.currentPage = convertNumberService.convertEng2Mm(this.courses.current_page);
            })
            .catch((error) => {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('/');
                }
                console.log("Course List API error", error);
            });     
        },
        
        getTeachersForFilter() {
            var Request = {
                params: {
                    course_type: 3,
                }
            };  
            axios.get("teacher/list/all", Request)
                .then((response) => {
                    this.teachers = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error);
                });
        },

        getSchoolsForFilter() {
            var Request = {
                params: {
                    course_type: 3,
                }
            }; 
            axios.get("school/list/all", Request)
                .then((response) => {
                    this.schools = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error);
                });
        },

        onChangeCategory(event) {
            this.filter.category_id = event.target.value;
        },

        onRegionChange(event) {
            var Value = event.target.value;
            this.filter.region = Value;
            this.selectedTwspName = "";
            this.twspName = this.changeTwspName(Value);
        },

        changeTwspName(value, twspName) {
            twspName = this.twspNameJson[value];
            return twspName;
        },

        onChangeTwspName(event) {
            var Value = event.target.value;
            this.filter.town = Value;
        },
        
        applyCourseFilter(page = 1) {
            this.filter.course_type = 3;
            this.filter.orderBy = this.sortBy;            
            axios.post("/course/list/filter?page=" + page, this.filter)
                .then((response) => {
                    this.pg_status = true;
                    this.courses = response.data;
                    this.courses.total = convertNumberService.convertEng2Mm(this.courses.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.courses.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.courses.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Course Filter Error", error);
                });
        },

        onChange(page = 1) {
            this.filter.course_type = 3;
            this.filter.orderBy = this.sortBy;
            axios.post("/course/list/filter?page=" + page, this.filter)
                .then((response) => {
                    this.pg_status = true;
                    this.courses = response.data;
                    this.courses.total = convertNumberService.convertEng2Mm(this.courses.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.courses.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.courses.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Course Filter Error", error);
                });
        },

        getCategoryForCourse() {
            axios.get("course/categories")
                .then((response) => {
                    this.category = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error);
                });
        },
        confirmLogin() {
            this.$modal.show("dialog", {
                title: "သင်သည် ကျောင်းသားတစ်ယောက် ဖြစ်ပါသလား?",
                text: "အတန်းအပ်ရန်အတွက် ကျောင်းသားအဖြစ် စာရင်းသွင်းရမည် သို့မဟုတ် မိမိအကောင့်သို့ ၀င်ရောက်ရမည်။",
                buttons: [{
                        title: "အကောင့်ဝင်ရန်",
                        handler: () => {
                            this.login();
                        }
                    },
                    {
                        title: "ပယ်ဖျက်ရန်",
                        handler: () => {
                            this.$modal.hide('dialog');
                        },
                    }
                ]
            });
        },

        login() {
            this.$router.push({
                name: "login"
            });
        },
        
        confirmEnroll(courseId) {
            this.isEnrolling = false; // Reset flag before showing dialog
            this.$modal.show("dialog", {
                title: "အတည်ပြုခြင်း!",
                text: "ဤအတန်းကိုတက်မှာ သေချာပြီလား?",
                buttons: [{
                        title: "တက်မည်",
                        default: true,
                        handler: () => {
                            if (!this.isEnrolling) {
                                this.isEnrolling = true; // Prevent further clicks
                                this.enrollCourse(courseId).finally(() => {
                                    this.isEnrolling = false; // Reset after completion
                                });
                            }
                        }
                    },
                    {
                        title: "မတက်ပါ",
                        handler: () => {
                            this.$modal.hide('dialog');
                        },
                    }
                ]
            });
        },
        enrollCourse(courseId) {
            var request = {
                course_id: courseId,
                student_id: this.studentId,
            };
            axios.post("/course/enroll", request)
                .then(() => {
                    this.getCourses();        
                    this.getCategoryForCourse();
                    this.getTeachersForFilter();
                    // this.courses = response.data;
                    // this.courses.total = convertNumberService.convertEng2Mm(this.courses.total);
                    // this.lastPage = convertNumberService.convertEng2Mm(this.courses.last_page);
                    // this.currentPage = convertNumberService.convertEng2Mm(this.courses.current_page);
                    this.$notification.success("ဤအတန်းကိုစာရင်းသွင်းခြင်းအောင်မြင်ပါသည်။ သက်ဆိုင်ရာ ဆရာ/ဆရာမ မှ ပြန်လည်ဆက်သွယ်ပေးပါလိမ့်မည်။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    this.$modal.hide("dialog");
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    else if(error.response.status == 400) {
                        this.$notification.error("ဤအတန်းကိုစာရင်းသွင်းပြီးပါပြီ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    } else {
                        this.class_error = error.errors;
                        this.$notification.error(this.class_error, {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }                   
                    this.$modal.hide("dialog");
                });
        },
    },

    mounted() {
        this.getCourses();       
        this.getCategoryForCourse();
        this.getTeachersForFilter();
        this.getSchoolsForFilter();

        $(document).ready(function() {
            $("#myBtn").click(function(event) {
                event.preventDefault();
                $("html, body").animate({
                    scrollTop: 0
                });
                return false;
            });
            $(window).on('load', function() {
                // Animate loader off screen
                $(".se-pre-con").fadeOut("slow");
            });
        });
    }
}
